import { configureStore } from '@reduxjs/toolkit'

import authReducer from '../features/auth/authSlice'
import usersReducer from '../features/users/usersSlice'
import uiReducer from '../features/ui/uiSlice'
import fundManagementReducer from '../features/fundManagement/fundManagementSlice'
import utilityReducer from '../features/utility/utilitySlice'

export const store = configureStore({
    reducer: {
        auth: authReducer,
        users: usersReducer,
        ui: uiReducer,
        fundManagement: fundManagementReducer,
        utility: utilityReducer,
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: {
                ignoredActions: ['persist/PERSIST'],
            },
        }),
    devTools: process.env.NODE_ENV !== 'production',
})

export default store
